<header class="flex flex-col gap-y-4">
  <p class="mx-dialog-title empty:hidden">{{ titleSelector | select:'' }}</p>

  <p class="mx-dialog-description text-body-large empty:hidden">{{ descriptionSelector | select:'' }}</p>
</header>

<div class="mx-dialog-content-wrapper">
  <div class="mx-dialog-content relative text-body-large empty:hidden">
    <ng-content/>
  </div>

  @if (promptSelector | select; as prompt) {
    <p class="mx-dialog-prompt text-title-large">{{ prompt }}</p>
  }
</div>

@if (showActionsDivider) {
  <mat-divider class="mt-3"/>
}

<mx-action-buttons [ngClass]="cancelButtonType === 'text' ? 'gap-x-2' : 'gap-x-4'">
  @if (showAdditionalActionButtons && !additionalButtonsAreConfirm) {
    <ng-container *ngTemplateOutlet="additionalButtonsContainer"/>
  }

  @if (showCancelButton) {
    @let cancelButtonLabel = cancelButtonLabelSelector | select;

    @switch (cancelButtonType) {
      @case ('text') {
        <mx-text-button [label]="cancelButtonLabel" [enabled]="enableCancelButton" (click)="onClickCancelButton()"/>
      }
      @case ('outlined') {
        <mx-outlined-button [label]="cancelButtonLabel" [enabled]="enableCancelButton" (click)="onClickCancelButton()"/>
      }
    }
  }

  @if (showConfirmButton) {
    @let confirmButtonLabel = confirmButtonLabelSelector | select;

    <mx-filled-button [label]="confirmButtonLabel" [enabled]="enableConfirmButton && !confirmationPending"
                      [customContentTemplate]="confirmationPending && showConfirmationPendingSpinner ? confirmationPendingContent : undefined"
                      (click)="onClickConfirmButton()"/>

    <ng-template #confirmationPendingContent>
      <mat-spinner [diameter]="24" class="[--mdc-circular-progress-active-indicator-color:var(--mx-button-filled-disabled-label-color)]"/>
      <span class="sr-only">{{ confirmButtonLabel }}</span> <!-- This label is visible only to screen readers -->
    </ng-template>
  }

  @if (showAdditionalActionButtons && additionalButtonsAreConfirm) {
    <ng-container *ngTemplateOutlet="additionalButtonsContainer"/>
  }
</mx-action-buttons>

<ng-template #additionalButtonsContainer>
  <ng-content select="[additionalActionButtons]"/>
</ng-template>
